import { atomWithStorage } from "jotai/utils";
import type { Field } from "../types/field";
import type { FieldObject } from "../types/fieldObject";

// fields
export const fieldsActionAtom = atomWithStorage<boolean>("fieldsAction", false);
export const fieldObjectsActionAtom = atomWithStorage<boolean>("fieldObjectsAction", false);
export const amountAtom = atomWithStorage<number>("amount", 5);
export const fieldObjectsAtom = atomWithStorage<FieldObject[]>("fieldObjects", []);
export const currentFieldsAtom = atomWithStorage<Field[]>("currentFields", []);
export const currentIndexAtom = atomWithStorage<number>("currentIndex", 0);
export const currentIdAtom = atomWithStorage<string>("currentId", "initial_object_id");
export const outputAtom = atomWithStorage("output", "");
